import { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from './Icon';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  gradient?: string;
}

const sizeClasses = {
  sm: 'max-w-md',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
  full: 'max-w-6xl',
};

export function Modal({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  size = 'lg',
  gradient = 'from-purple-600 to-indigo-600',
}: ModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            className={`bg-white rounded-xl shadow-2xl ${sizeClasses[size]} w-full my-8 max-h-[90vh] overflow-hidden flex flex-col`}
          >
            <div className={`bg-gradient-to-r ${gradient} text-white px-6 py-4 flex justify-between items-center flex-shrink-0`}>
              <div>
                <h2 className="text-2xl font-bold">{title}</h2>
                {subtitle && <p className="text-white/80 text-sm mt-1">{subtitle}</p>}
              </div>
              <button onClick={onClose} className="text-white hover:text-gray-200 transition">
                <Icon name="X" size={24} />
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}